import EmailCredentialModel from '@/common/models/email-credential-model';

export default function getCredentialDelegate(data, {type}) {
    return ({credentialHashes}) => {
        const delegate = (() => {
            switch (type) {
                case EmailCredentialModel.Types.smtp:
                default:
                    return credentialHashes.createEmailCredential;
                case EmailCredentialModel.Types.mailgun:
                    return credentialHashes.createMailgunCredential;
                case EmailCredentialModel.Types.awsSES:
                    return credentialHashes.createAWSSESCredential;
                case EmailCredentialModel.Types.sendGrid:
                    return credentialHashes.createSendGridCredential;
                case EmailCredentialModel.Types.postmark:
                    return credentialHashes.createPostmarkCredential;
            }
        })();
        return delegate({data});
    };
}
